export default "__VITE_ASSET__BDwk9$NN__"